// import { select as d3_select } from 'd3-selection'

import BaseViz from './BaseViz'
import LollipopBarChartChart from '../charts/LollipopBarChartChart'
import LollipopBarChartDataController from '../viz_behaviors/LollipopBarChartDataController'
import { encodeDate } from '@/utils/dates'

export default class LollipopBarChartViz extends BaseViz {
  static defaultConfig = {
    colorMode: {
      type: String,
      default: 'normal',
      options: ['normal', 'tritanopia'],
    },
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical', 'single'],
      },
    },
    AxisHelper: {
      x: {
        trimThreshold: {
          nonEditable: true,
          exposed: false,
        },
        valueFormat: {
          nonEditable: true,
          exposed: false,
        },
        unit: {
          nonEditable: true,
          exposed: false,
        },
        scale: {
          nonEditable: true,
        },
      },
    },
    TooltipBehavior: {
      getHtml: function(d) {
        const self = this

        function valueScale(values) {
          const domain = self.axes.y.scale.domain()
          const max = Math.max(...values, domain[1])
          const min = Math.min(...values, domain[0])
          const range = max - min

          return function(v) {
            return 45 - ((v - min) / range) * 40
          }
        }

        function path(scale, serie, width) {
          var path = `M 0 ${scale(serie[0])}`
          const len = serie.length - 1
          if (len === 0) return path + ' Z'
          serie.forEach((d, i) => {
            path += ` L ${(i / len) * width} ${scale(d)}`
          })
          return path
        }

        function evolutiveChart(values) {
          if (values.length === 0) return '<svg class="evolutive" width="200" height="45"></svg>'
          const width = 200
          const height = 45
          const scale = valueScale(values)
          return `<div class="evolutive-root">
            <svg class="evolutive" width="${width}" height="${height}">
              <g class="axis">
                <line class="grid-line" stroke="#bbb" shape-rendering="crispedges" stroke-width="1" x1="0" x2="${width}" y1="10" y2="10"></line>
                <line class="grid-line" stroke="#bbb" shape-rendering="crispedges" stroke-width="1" x1="0" x2="${width}" y1="20" y2="20"></line>
                <line class="grid-line" stroke="#bbb" shape-rendering="crispedges" stroke-width="1" x1="0" x2="${width}" y1="30" y2="30"></line>
                <line class="grid-line" stroke="#bbb" shape-rendering="crispedges" stroke-width="1" x1="0" x2="${width}" y1="40" y2="40"></line>
              </g>
              <path d="${path(
                scale,
                values,
                width
              )}" fill="none" stroke="#4283E3" stroke-width="2" />
            </svg>
          </div>`
        }

        function b64LollipopIcon(i) {
          const svg =
            '<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500">' +
            '<polygon fill="' +
            (i === 0
              ? self.config.ItemsHelper.colorDict.all.color
              : self.config.colorMode == 'normal'
              ? '#7C4DFF'
              : '#bbb') +
            '" stroke="#fff" stroke-width="0" points="' +
            self.candyPolygonPoints(i - 1, 250) +
            '" style="transform: translate(250px, 250px)"></polygon></svg>'
          return 'url(data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg))) + ')'
        }

        if (d.lollipop.length === 0) {
          const isNDSC = Boolean(location.href.match(/maincubeid=[^&]+DF_NDSC&/i))
          const href = location.href
            .replace(/barchart/, 'linechart')
            .replace(/countries=[^&]*/, 'countries=' + d.id)
          let html = `<div class="columns">
            <div class="column">
              <p class="important">${d.label}</p>
              <p>${encodeDate(d.year)}</p>
            </div>
            <div class="column">
              <p class="value">${this.valueWithUnit(d.value, 'y_1')}</p>
            </div>
          </div>`
          if (!isNDSC) {
            const chart = evolutiveChart(this.config.TooltipBehavior.evolutive.map(d => d[2]))
            html += chart + `<a target="" href="${href}">View change over time</a>`
          }
          return html
        } else {
          const legend = this.getLegendData()
          return (
            `<div class="rows">
            <div class="row">
              <div class="column">
                <div class="important">${d.label}</div>
                <p>${encodeDate(d.year)}</p>
              </div>
            </div>
            <div class="row">
              <div class="icon" style="background-image: ${b64LollipopIcon(0)}"></div>
              <div class="column lollipop-label">${legend[0].label}</div>
              <div class="column value">${this.valueWithUnit(d.value, 'y_1')}</div>
            </div>` +
            d.lollipop
              .map((datum, i) => {
                if (datum.value === null) return ''
                return `<div class="row">
                <div class="icon" style="background-image: ${b64LollipopIcon(i + 1)}"></div>
                <div class="column lollipop-label">${legend[i + 1].label}</div>
                <div class="column value">${this.valueWithUnit(datum.value, 'y_1')}</div>
              </div>`
              })
              .join('') +
            '</div>'
          )
        }
      },
    },
  }

  static chartClass = LollipopBarChartChart
  static dataControllerClass = LollipopBarChartDataController
}
